export default __webpack_public_path__ + "static/media/deauville07.26bf9cfe.jpg";